import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {translate} from '@elements/translations';
import {findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';

const isDesktop = matchMedia('(min-width: 768px)').matches;
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    submitOnChange: isDesktop,
    addUrlParams: true
});

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as filterOverlay from './scripts/filter-overlay';
filterOverlay.init();

import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multipleSelectDropdown from './scripts/multiselect-dropdown';
multipleSelectDropdown.init();

import * as copyToClipboard from './scripts/copy-to-clipboard';
copyToClipboard.init();